/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Responsibility_Reliability25Inputs */

const en_job_form_enum_responsibility_reliability25 = /** @type {(inputs: Job_Form_Enum_Responsibility_Reliability25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsibility and Reliability`)
};

const de_job_form_enum_responsibility_reliability25 = /** @type {(inputs: Job_Form_Enum_Responsibility_Reliability25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verantwortungsbewusstsein und Zuverlässigkeit`)
};

/**
* | output |
* | --- |
* | "Responsibility and Reliability" |
*
* @param {Job_Form_Enum_Responsibility_Reliability25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_responsibility_reliability25 = /** @type {((inputs?: Job_Form_Enum_Responsibility_Reliability25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Responsibility_Reliability25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_responsibility_reliability25(inputs)
	return en_job_form_enum_responsibility_reliability25(inputs)
});
export { job_form_enum_responsibility_reliability25 as "job_form_enum_RESPONSIBILITY_RELIABILITY" }